/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { resourceResponseSchema } from './resourceResponseSchema';

export const pageResponseResourceResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(resourceResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
